import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const DeviceWrapper = styled('section')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    gap: 24px;
`

export const DomainItem = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 8px;
`
